import { observable, action } from 'mobx';

class CustomerDetail {
  @observable customerValue = {}

  @observable modal = {}

  @observable modalChildren = {}

  @action getCustomerDetail = (value) => {
    if (this.modalChildren.specName) {
      this.customerDetail = '';
    } else {
      this.customerDetail += value;
    }
  }

  @action getModal = (value) => {
    this.modal = value;
  }

  @action getModalChildren = (value) => {
    this.modalChildren = value;
  }

  @action setCustomerValue = (value, type) => {
    if (type) {
      Object.keys(value).map((v) => {
        this.customerValue[v] = value[v];
        return v;
      });
    } else {
      this.customerValue = value;
    }
  }

  @action modal = (value) => {
    this.customerValue = value;
  }
}
export default new CustomerDetail();
